/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export * from './auth.options';
export * from './auth.module';
export * from './auth.routes';

export * from './components/auth.component';
export * from './components/auth-block/auth-block.component';
export * from './components/login/vta.login.component';
export * from './components/logout/logout.component';
export * from './components/register/vta.register.component';
export * from './components/request-password/vta.request-password.component';
export * from './components/reset-password/vta.reset-password.component';
export * from './models/user';

export * from './helpers';
